export default "__VITE_ASSET__jXvTpZWI__"